"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaobabSendWay;
(function (BaobabSendWay) {
    BaobabSendWay["NoSend"] = "no send";
    BaobabSendWay["SendBeacon"] = "sendBeacon";
    BaobabSendWay["Ajax"] = "ajax";
    BaobabSendWay["Img"] = "tag img";
})(BaobabSendWay = exports.BaobabSendWay || (exports.BaobabSendWay = {}));
